export default [
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/accreditation-agreed',
        name: 'Accreditation_agreed',
        component: () => import("@/pages/Founders/AccreditationAgreed"),
        meta:{
            needContact: true,
            roles: ['FOUNDER_ROLE', 'CO_ROLE', 'ADMIN_ROLE'],
        }
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/accreditation-agreed-sign',
        name: 'Accreditation_agreed_sign',
        component: () => import("@/pages/Founders/AccreditationAgreedSign"),
        meta:{
            needContact: true,
            roles: ['FOUNDER_ROLE', 'CO_ROLE', 'ADMIN_ROLE'],
        }
    }
]